
class Utils {
	constructor(){

	}
	// 解析url参数并获取code
	getUrlParam(name) { //name为要获取的参数名
		let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
		let rrr = decodeURIComponent(window.location.search);
		let r = rrr.substr(1).match(reg);
		if(r != null) return unescape(r[2]);
		return null;
	}
	//  经纬度取整
	getLatLon(lat, lon) {
		lat = lat.toFixed(2);
		lon = lon.toFixed(2);
		return [lat, lon]
	}
	// 风等级转换
	getWindLevel(l) {
		if (typeof (l) == 'undefined') {
			return;
		} else if (l <= 0.2) {
			return '静风';
		} else if (l <= 1.6) {
			return '1级';
		} else if (l <= 3.4) {
			return '2级';
		} else if (l <= 5.4) {
			return '3级';
		} else if (l <= 7.9) {
			return '4级';
		} else if (l <= 10.7) {
			return '5级';
		} else if (l <= 13.8) {
			return '6级';
		} else if (l <= 17.1) {
			return '7级';
		} else if (l <= 20.7) {
			return '8级';
		} else if (l <= 24.4) {
			return '9级';
		} else if (l <= 28.4) {
			return '10级';
		} else if (l <= 32.6) {
			return '11级';
		} else if (l > 32.6) {
			return '12级';
		}
	}
	// 0-8风向转换
	changeDirection(num){
		if(num == 0){ return '静风';}
		else if(num == 1){ return '北风';}
		else if(num == 2){ return '东北风';}
		else if(num == 3){ return '东风';}
		else if(num == 4){ return '东南风';}
		else if(num == 5){ return '南风';}
		else if(num == 6){ return '西南风';}
		else if(num == 7){ return '西风';}
		else if(num == 8){ return '西北风';}
	}
	// 360度 风向转换
	getWindDirection(val) {
		// val = Math.floor((val+22.5)/45);
		if (val >= 337.5 || val < 22.5) { return "北风"; }
		else if (val < 67.5) { return "东北风"; }
		else if (val < 112.5) { return "东风"; }
		else if (val < 157.5) { return "东南风"; }
		else if (val < 202.5) { return "南风"; }
		else if (val < 247.5) { return "西南风"; }
		else if (val < 292.5) { return "西风"; }
		else if (val < 337.5) { return "西北风"; }
		// else if(val < 337.5){return "旋转风";}
	}
	// 按一定长度切割成多个数组
	divisionArr(arr, len) {
		let newArray = [];
		let num = 0;
		for (let i = 0; i < arr.length; i++) {
			// 当i 等于截取长度len 的倍数的时候 从 num 开始截取到 i的位置结束 push 到新的数组  并将i的位置作为下次开始截取起点
			if (i % len == 0 && i != 0) {
				newArray.push(arr.slice(num, i))
				num = i;
			}
			//i已是最后一个 元素 就从 num 截取到最后 并push 到新数组
			if ((i + 1) == arr.length) {
				newArray.push(arr.slice(num, (i + 1)))
			}
		}
		return newArray;
	}
	//经纬度转换成三角函数中度分表形式。
	Rad(d){
		return  d * Math.PI / 180.0;
	}
	//用haversine公式计算球面两点间的距离。
	HaverSin(theta){
		var v = Math.sin(theta / 2);
		return v * v;
	}
	//通过经纬度 计算距离
	getDistance(coordsA,coordsB) {	
		//经纬度转换成弧度
		let lat1 =this.Rad(coordsA.lat);
		let lon1 =this.Rad(coordsA.lon);
		let lat2 =this.Rad(coordsB.lat);
		let lon2 =this.Rad(coordsB.lon);
		//差值
		let vLon = Math.abs(lon1 - lon2);
		let vLat = Math.abs(lat1 - lat2);
		//h is the great circle distance in radians, great circle就是一个球体上的切面，它的圆心即是球心的一个周长最大的圆。
		let h = this.HaverSin(vLat) + Math.cos(lat1) * Math.cos(lat2) * this.HaverSin(vLon);
		let distance = 2 * 6371.0 * Math.asin(Math.sqrt(h));
		return distance;//千米
	}
	// 对象深拷贝
	deepClone (source){
		const targetObj = source.constructor === Array ? [] : {}; // 判断复制的目标是数组还是对象
		for(let keys in source){ // 遍历目标
		  if(source.hasOwnProperty(keys)){
			  // 如果值是对象，就递归一下
			if(source[keys] && typeof source[keys] === 'object'){
			  targetObj[keys] = source[keys].constructor === Array ? [] : {};
			  targetObj[keys] = this.deepClone(source[keys]);//递归复制目标对象
			}else{ // 如果不是，就直接赋值
			  targetObj[keys] = source[keys];
			}
		  }
		}
		return targetObj;
	}
	//时间戳转日期格式 
	formatTime(datetimes, format) {
		let formateArr = ['Y', 'M', 'D', 'h', 'm', 's'];
		let returnArr = [];
		let date = new Date(datetimes);
		returnArr.push(date.getFullYear());
		returnArr.push(this.formatNumber(date.getMonth() + 1));
		returnArr.push(this.formatNumber(date.getDate()));
		returnArr.push(this.formatNumber(date.getHours()));
		returnArr.push(this.formatNumber(date.getMinutes()));
		returnArr.push(this.formatNumber(date.getSeconds()));
		for (let i in returnArr) {
			format = format.replace(formateArr[i], returnArr[i]);
		}
		return format;
	}
	//数据转化  
   	formatNumber(n) {
		n = n.toString()
		return n[1] ? n : '0' + n
	}
}

// 导出实例
export default  new Utils();


// WEBPACK FOOTER //
// ./src/common/js/utils.js